// extracted by mini-css-extract-plugin
export default {"ParticipatingPharmacies":"_2Hajzuvo","ParticipatingPharmaciesWrapper":"pmJMb6r8","ParticipatingPharmaciesTextWrapper":"DPS7YSL5","ParticipatingPharmaciesLogos":"oI92Ywmn"};